// @ts-nocheck
/**
 * ZoomedPlayerManager - Handles zooming Twitch players
 */
export class ZoomedPlayerManager {
    constructor(playerManager) {
        this.playerManager = playerManager;
    }

    /**
     * Toggle zoomed state for a player
     */
    zoomPlayer(streamerId) {
        const player = this.playerManager.players.get(streamerId);
        if (!player) return;
        
        // Un seul player peut occuper un mode prioritaire à la fois.
        this.playerManager.players.forEach((otherPlayer, id) => {
            if (otherPlayer.maximized) this.playerManager.disableMaximizedMode(id);
        });
        
        // Désactiver le zoom sur tous les autres players d'abord
        this.playerManager.players.forEach((p, id) => {
            if (id !== streamerId && p.zoomed) {
                this.playerManager.disableZoomMode(id);
            }
        });
        
        // Toggle state
        player.zoomed = !player.zoomed;

        if (player.zoomed) {
            this.playerManager.focusAudioOnPlayer(streamerId);
        }
        
        // Reset maximized state if active
        if (player.maximized) {
            player.maximized = false;
            const maxButton = player.element.querySelector('.player-controls button:nth-child(2) i');
            maxButton.className = 'fas fa-expand';
        }
        
        // Apply changes to all players
        requestAnimationFrame(() => {
            // Reset all players first
            this.playerManager.players.forEach((p) => {
                p.element.classList.remove('player-zoomed', 'player-below-zoomed');
                // Réinitialiser explicitement les styles qui pourraient interférer
                if (p.element.style) {
                    p.element.style.gridColumn = '';
                    p.element.style.gridRow = '';
                    p.element.style.width = '';
                    
                    // Reset any order property when changing zoom state
                    p.element.style.order = '';
                }
            });
            
            // Toggle zoom-active class on container
            this.playerManager.container.classList.toggle('zoom-active', player.zoomed);
            
            if (player.zoomed) {
                // Apply zoomed layout
                player.element.classList.add('player-zoomed');
                
                // When zooming, position at the top regardless of order
                player.element.style.order = '-1';
                
                // Move other players below without recreating their iframes.
                this.playerManager.players.forEach((p, id) => {
                    if (id !== streamerId) {
                        p.element.classList.add('player-below-zoomed');
                    }
                });
                
                // Adjust container to show players without scroll
                this.playerManager.container.style.gridTemplateColumns = 'repeat(5, 1fr)';
                this.playerManager.container.style.gridAutoRows = 'min-content';
                // Important: Reset grid-auto-flow to ensure consistent behavior
                this.playerManager.container.style.gridAutoFlow = 'row';
                
                // Change button icon
                const zoomButton = player.element.querySelector('.player-controls button:first-child i');
                zoomButton.className = 'fas fa-search-minus';
                
                // Scroll to top to ensure zoomed player is visible
                this.playerManager.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                // Change button icon back
                const zoomButton = player.element.querySelector('.player-controls button:first-child i');
                zoomButton.className = 'fas fa-search-plus';
                
                // Return to normal layout
                this.playerManager.container.style.gridAutoRows = '';
                this.playerManager.updateLayout();
            }

            this.playerManager.syncPlayerModeControls(streamerId);
            this.playerManager.syncAllPlayerPerformance();
        });
    }
}
